import { render, staticRenderFns } from "./jindu.vue?vue&type=template&id=00c1566d&scoped=true"
import script from "./jindu.vue?vue&type=script&lang=js"
export * from "./jindu.vue?vue&type=script&lang=js"
import style0 from "./jindu.vue?vue&type=style&index=0&id=00c1566d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1566d",
  null
  
)

export default component.exports